import { render, staticRenderFns } from "./platform.vue?vue&type=template&id=ca72c0b6&scoped=true"
import script from "./platform.vue?vue&type=script&lang=js"
export * from "./platform.vue?vue&type=script&lang=js"
import style0 from "./platform.vue?vue&type=style&index=0&id=ca72c0b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca72c0b6",
  null
  
)

export default component.exports